import React, {Component} from 'react';
import moment from 'moment';
import 'rc-tooltip/assets/bootstrap_white.css';
import { Panel } from 'react-bootstrap';

export default class TablaInmatriculacionCorreo extends Component {
    constructor(props) {
        super(props);
        this.state = {
            selected: [],
            rowSelected: [],
            showFilter: false,
            showModeTarget: 'none',
            checkCodPlanEntrVehi: '',
            checkRowsPerdido: {},
        };
    }

    functionDespliegue = (index) => {
        const isExpanded = index === this.state.rowSelected;
        return isExpanded;
    }

    toggleRow = (index) => {
        if (index === this.state.rowSelected) {
            this.setState({rowSelected: ''});
        } else {
            this.setState({rowSelected: index});
        }
    };

    functionDespliegue = (index) => {
        const isExpanded = index === this.state.rowSelected;
        return isExpanded;
    };


    toggleRow = (index) =>{
        if (index === this.state.rowSelected) {
            this.setState({ rowSelected: '' });
        } else {
            this.setState({ rowSelected: index });
        }
    }

    activeTarget = (codigo, Rows) => {

        this.setState({
            showModeTarget: 'block',
            checkCodPlanEntrVehi: codigo,
            checkRowsPerdido: Rows,
        });
    }
    activeTargetClose = () => {
        this.setState({showModeTarget: 'none'});
    }

    render() {
        return (
            <section>
                <div className='tableWrapper'>
                    <div className='hidden-xs'>
                        <table className='table table-hover' style={{marginBottom: '140px'}}>
                            <thead className='table-head'>
                            <tr>
                                <th>
                                    <div className='checkbox checkbox-inline'>
                                        <label>
                                            <input type='checkbox' id={'checkBoxAll'} onClick={() => this.props.selectAll()} />
                                            <div className='checkbox-skin' />
                                        </label>
                                    </div>
                                </th>
                                <th>CLIENTE</th>
                                <th>N° DE PEDIDO</th>
                                <th>ESTADO</th>
                                <th>N° CHASIS</th>
                                <th>OFICINA REGISTRAL</th>
                                <th>TITULO</th>
                                <th>F° TITULO</th>
                                <th>F° CARGA</th>
                                <th/>
                                <th/>
                            </tr>
                            </thead>

                            {
                                this.props.registros.map((Rows, i) => (
                                    <tbody key={i} >
                                    <tr key={i} >
                                        <td>
                                            <div className='checkbox checkbox-inline'>
                                                <label>
                                                    <input type='checkbox' checked={this.props.selectedID.indexOf(Rows.numPedidoVeh)>=0} />
                                                    <div className='checkbox-skin' onClick={() => this.props.handleOnClickAll(Rows.numPedidoVeh, Rows)} />
                                                </label>
                                            </div>
                                        </td>
                                        <td className='col-sm-3'>{Rows.desCliente}</td>
                                        <td className='col-sm-1'>{Rows.numPedidoVeh}</td>
                                        <td className='col-sm-1'>{Rows.estadoPedido}</td>
                                        <td>{Rows.numChasis}</td>
                                        <td className='col-sm-3'>{Rows.oficinaRegistral}</td>
                                        <td>{Rows.titulo}</td>
                                        <td>{(Rows.fechaTitulo) ? (Rows.fechaTitulo.toString().indexOf('/')!==-1?Rows.fechaTitulo:moment(new Date(Rows.fechaTitulo)).format("DD/MM/YYYY")): "-"}</td>
                                        <td>{(Rows.fechaCarga) ? moment(new Date(Rows.fechaCarga)).format("DD/MM/YYYY") : "-"}</td>
                                        <td onClick={() => this.toggleRow(i)} className='ion-chevron-down ml-3 c-cyan  open'  />
                                        <td>

                                            <div className='dropdown kebab' role='group'>
                                                <button className='btn dropdown-toggle kebab-btn pull-right'
                                                        name={'btnDropdownToggle'}><i
                                                    className='ion-android-more-vertical' name={'iconDropdownToggle'}/>
                                                </button>
                                                {
                                                    <ul className='dropdown-menu dropdown-menu-right'>
                                                        <li key={'DETALLE'}><a
                                                            onClick={() => {
                                                                this.props.seleccionar(Rows);
                                                                this.props.openModal('ver-facturas', this)
                                                            }}><i
                                                            className='ion-eye c-cyan'/><span>Ver Facturas</span></a>
                                                        </li>
                                                        <li key={'CORREO'}><a
                                                            onClick={() => {
                                                                this.props.seleccionar(Rows);
                                                                this.props.openModal('enviar-correo', this)
                                                            }}><i
                                                            className='ion-calendar c-cyan'/><span>Enviar Correo</span></a>
                                                        </li>
                                                    </ul>
                                                }
                                            </div>
                                        </td>
                                    </tr>
                                    <tr className='table-extra' >
                                        <td colSpan='11'>
                                            <Panel collapsible expanded={this.functionDespliegue(i)} style={{ borderColor: 'transparent', boxShadow: '0 0 0 white', margin: '0', backgroundColor: 'inherit' }}>
                                                <div className='collapse in'>
                                                    <div className='table-extra-wrap'>
                                                        <ul className='row'>
                                                            <li className='col-md-12'>
                                                                <p className='labelInfo'>SITUACIÓN</p>
                                                                <p>{Rows.situacionInmatriculacion}</p>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                </div>
                                            </Panel>
                                        </td>
                                    </tr>
                                    </tbody>
                                ))
                            }
                        </table>
                    </div>
                </div>
            </section>

        );
    }
}



// WEBPACK FOOTER //
// ./src/containers/tablasInmatriculacion/tblInmatriculacionCorreo.js